import React__default from 'react';
import CustomerSupport from './CustomerSupport.js';
import { useCreateTicket } from './hooks/use-create-ticket.js';

const CustomerSupportContainer = (props)=>{
    const [onSubmit, result] = useCreateTicket();
    return /*#__PURE__*/ React__default.createElement(CustomerSupport, {
        onSubmit: onSubmit,
        isLoading: result.isLoading,
        showErrorMessage: !!result.error,
        showSuccessMessage: result.isSuccessful,
        isCustomerIDActivated: props.isCustomerIDActivated,
        showConsent: props.showConsent
    });
};
var CustomerSupportContainer$1 = CustomerSupportContainer;

export { CustomerSupportContainer$1 as default };
//# sourceMappingURL=CustomerSupportContainer.js.map
